var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.026 16c0 7.732-6.274 14-14.013 14C8.273 30 2 23.732 2 16S8.274 2 16.013 2c7.74 0 14.013 6.268 14.013 14zm-5.555 1.208v-4.65H7.451v9.95c0 .925.762 1.674 1.702 1.674h13.617c.94 0 1.701-.75 1.701-1.674v-3.905h-2.748a6.44 6.44 0 0 1-5.772 3.533c-3.064 0-5.628-2.107-6.274-4.928h14.795zm-8.52 3.544a5.03 5.03 0 0 0 4.14-2.15h-8.28a5.03 5.03 0 0 0 4.14 2.15zm-6.251-4.846c.182-1.262 1.286-2.231 2.62-2.231 1.334 0 2.437.97 2.62 2.231h-1.45a1.228 1.228 0 0 0-1.17-.837c-.547 0-1.01.35-1.17.836H9.699zm7.28 0c.184-1.262 1.287-2.231 2.621-2.231 1.335 0 2.439.97 2.622 2.231h-1.45a1.228 1.228 0 0 0-1.17-.837c-.548 0-1.011.35-1.17.836H16.98zm7.491-6.788c.001-.924-.76-1.673-1.7-1.673H9.151c-.94 0-1.702.749-1.702 1.673v2.046H24.47V9.118z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/MASK.f29962ab846070ed26f1d5cdc5cdbf0e.svg";
export { ForwardRef as ReactComponent };